import React from 'react';
import PropTypes from 'prop-types';
import {
  nativeFunction,
  callNativeFunction,
  nativeFunctionParamsConstant,
} from '@/utils/detectDevice';
import DiamondHeader from '@/components/Lottie/DiamondHeader';
import Diamond from '@/assets/images/exercises/header/diamond.png';
import ThemeContext from '../theme-context';
import Voice from '../Voice';
import './style.less';

class Header extends React.Component {
  static propTypes = {
    audioSrc: PropTypes.string,
    diamond: PropTypes.bool,
    back: PropTypes.func,
    audioStop: PropTypes.func,
    audioPlay: PropTypes.func,
  };

  state = {
    playing: false,
  }

  handleBack = () => {
    callNativeFunction(nativeFunction.STOP_LOCAL_ALL)({
      type: nativeFunctionParamsConstant.FLIP,
    });
    this.props.back();
  };

  switchAudio = (e) => {
    e.preventDefault();
    const { playing } = this.state;
    if (playing) {
      this.props.audioStop();
      document.querySelector('.card-modal') !== null && (document.querySelector('.card-modal').className = 'card-modal');
    } else {
      this.props.audioPlay(this.props.audioSrc, { type: 'header' });
      document.querySelector('.card-modal') !== null && (document.querySelector('.card-modal').className = 'card-modal block');
    }
  };

  audioPlay = () => this.setState({ playing: true });

  audioEnd = () => this.setState({ playing: false });

  render() {
    const { diamond } = this.props;
    return (
      <div className={`exercises_header ${this.context}`}>
        <div className={`exercises_back ${this.context}`} onClick={this.handleBack} />
        <div className="exercises_title">
          <img id="exercisesDiamond" className={`exercises_diamond ${diamond}`} src={Diamond} alt="" />
          {diamond && <div className="diamond-header"><DiamondHeader /></div>}
          <div className={`exercises_text ${this.context}`} />
        </div>
        {!this.state.playing
          ? <div className={`exercises_voice ${this.context}`} onClick={this.switchAudio} />
          : <div className="exercises_voice_animation" onClick={this.switchAudio}><Voice /></div>
        }
        <div className="exercises_modal" />
      </div>
    );
  }
}

Header.contextType = ThemeContext;

export default Header;
